import { ChangeDetectionStrategy, Component, OnInit, inject, ViewChild, AfterViewInit, QueryList, ViewChildren, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BizEntityChildrenStatusStoreService, FormBaseEntityComponent } from '@optima-stride-ai/optima-app-framework';
import { ModalButtonIDs } from "../../biz-entity/form-base-entity/form-base-entity.component";
import { AdditionalInfoComponent } from '@optima-stride-ai/optima-app-framework';
import {  IFormLayout, IFormLayoutContent, IFormLayoutFooter, IFormLayoutHeader, ToastService, IListView, ListerComponent, ProgressIndicatorComponent, ProcessProgressType, ProcessProgressView, ShimmerVariant, iProcessProgress, IOptionWithoutIcon } from '@optima-stride-ai/optima-components';
import { IAdditionalInfo, IRelationshipConfiguration, FieldTypes, Unit, Units, IOptionWithIcon, IFieldMeta, IBizEntity, IBizEntityRelationships, IBizEntityType, BizEntityTypeCategory, IBizEntityRelationTarget, RelationshipTargetType, RelationshipLinkType,AdvancedMathService, BizInformationTypes  } from '@optima-stride-ai/core';
import {Selections, QueryDataTypes, ValueKinds, Selection, OrderByDirections, FactDefinitionTypes, IFactAndValue, FilterExpressions, GroupBys, MoreSection, getSymbol, getOperator, Operators, LogicalOperators, NodeKind} from '@optima-stride-ai/core';
import { IKPI } from '../kpi.model';
import { DateRange } from '../../../models/interfaces/date-range-model';
import { IMeasure, KPIAndMeasureCategories } from '../../transaction(Measure)/measure.model';
import { KpiExplorerComponent } from '../kpi-explorer/kpi-explorer.component';
import { initFormStateFunc } from '../../utils/form/function-init-form-state';
import { AppStateService } from '../../state/app-state';
import { notifyStrategyEntityCreated } from '../../strategy/strategy-explorer/strategy-explorer-creation';
import { KpiStateStoreService, temporarykpiSyncBeforeSendingToAPI } from '../../kpi/KPI-state-stores/kpi-state-store.service';
import { FormRelationshipFieldsComponent } from '@optima-stride-ai/optima-app-framework';
import { UtilService } from '../../utils/util.service';
import { BizEntityTypeStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { FormStates } from '../../utils/form/form-interfaces';
import { MeasuresStateStoreService } from '../../transaction(Measure)/measure-state-store/measures-state-store.service';
import { IBenBizEntity } from '../../../models/interfaces/biz-entity.model';
import { AppRootStateStoreService, benBizEntitySyncBeforeSendingToAPI, BizEntityStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { AutoCreateEntitiesService } from '../../kpi/auto-create-entites';
import { RelationshipStateStoreService, AppFrameworkContextService, IXappCap } from '@optima-stride-ai/optima-app-framework';
import { TenantStateStoreService, UserContextService } from '@optima-stride-ai/optima-platform';
import { Explorers, GetDefaultConfig, getExplorerPropertiesBasedOnBizEntityType, launchExplorerDialog, ModalDialogs, ModalDialogSizes } from '../../modal/modal';
import { OptimaDefaultModalService } from '../../modal/modal.service';
import { CardModule, CardComponent, CardBodyComponent, CardHeaderComponent } from '@coreui/angular';
import { faker } from '@faker-js/faker';
import { DataQueryRule } from '@optima-stride-ai/core';
import {IPolymorphicControlMeta, PolymorphicControlService, PolyMorphicControlTypes,FormLayoutComponent } from '@optima-stride-ai/optima-components';
import { DqrTransformationMethodsService } from './dqr-transformation-methods.service';

@Component({
  selector: 'app-form-kpi',
  imports: [CommonModule, FormBaseEntityComponent, AdditionalInfoComponent, FormLayoutComponent, ReactiveFormsModule, FormRelationshipFieldsComponent, CardModule, CardComponent, CardBodyComponent, CardHeaderComponent, ListerComponent, ProgressIndicatorComponent],
  templateUrl: './form-kpi.component.html',
  styleUrl: './form-kpi.component.sass',
  standalone: true
}) 

export class FormKPIComponent implements OnInit {
  @ViewChild('baseEntityForm') baseEntityFormComponent!: FormBaseEntityComponent; // already correct selector reference
  @ViewChild('additionalInfoForm') additionalInfoFormComponent!: AdditionalInfoComponent;
  @ViewChildren('relationshipFields') relationshipFieldsComponents!: QueryList<FormRelationshipFieldsComponent>;

  formLayout: IFormLayout = { 
    header: { title: '' }, 
    content: { fieldItems: [] }, 
    footer: { actions: [] } 
  };
  formFooterLayout: IFormLayout = { 
    header: { title: '' }, 
    content: { fieldItems: [] }, 
    footer: { actions: [] } 
  };
  relationshipConfigurations: IRelationshipConfiguration[] = [];
  relationshipAdditionalInfo: {config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[]}[] = []; 
  relationshipAdditionalInfoForEdit: {config: IRelationshipConfiguration, bizEntity: IBizEntity}[] = [];
  
  bizEntities: IBizEntity[] = [];
  extractedTargetBizEntities: IBizEntity[] = [];
  
  isEditing: boolean = false;
  protected isFormLoading = true;
  private baseFormReady = false;
  private flowDataReady = false;
  protected readonly formLoadingProgress: iProcessProgress = { id: 'form-kpi-loading', type: ProcessProgressType.Indeterminate };
  protected readonly ProcessProgressView = ProcessProgressView;
  protected readonly ShimmerVariant = ShimmerVariant;
  private isAPICallInProgress: boolean = false;
  private currentAppId: string | undefined;

  get formHeaderTitle(): string {
    return this.kpiBizEntity?.type?.name || 'KPI';
  }

  get formHeaderSubtitle(): string {
    const typeName = this.kpiBizEntity?.type?.name || 'KPI';
    const entityName = this.kpiBizEntity?.name || typeName;
    return this.isEditing
      ? `Edit ${entityName} to track strategy`
      : `Create ${typeName} to track strategy`;
  }
  kpiBizEntity!: IKPI;
  private selectedMeasureObj!: IMeasure;
  private statusOptions: IOptionWithIcon [] = [];



  private readonly polymorphicControlService = inject(PolymorphicControlService);
  private readonly appStateService = inject(AppStateService);
  private readonly kpiStateStoreService = inject(KpiStateStoreService);
  private readonly utilService: UtilService = inject(UtilService);
  private readonly bizEntityTypeStateStoreService = inject(BizEntityTypeStateStoreService);
  private readonly toastService = inject(ToastService);
  private readonly measureStateStoreService  = inject(MeasuresStateStoreService) ;
  private readonly autoCreateEntitiesService = inject(AutoCreateEntitiesService);
  private readonly relationshipStateStoreService = inject(RelationshipStateStoreService);
  private readonly bizEntityStateStoreService = inject(BizEntityStateStoreService);
  private readonly appRootStateStoreService = inject(AppRootStateStoreService);
  private readonly bizEntityChildrenStatusStoreService = inject(BizEntityChildrenStatusStoreService);
  private readonly optimaDefaultModalService = inject(OptimaDefaultModalService);
  private readonly appFrameworkContextService = inject(AppFrameworkContextService);
  private readonly tenantStateStoreService = inject(TenantStateStoreService);
  private readonly userContextService = inject(UserContextService);
  private readonly mathService = inject(AdvancedMathService);
  private readonly dqrTransformationMethodsService = inject(DqrTransformationMethodsService);
  private isStatusFieldDisabled: boolean = true;
  private showStatusField: boolean = false;
  // Once filter is avaliable this will all be handled by the generic explorer
  // This is a temporary solution until the generic explorer has filter capabilities
  private selectedParentEntity?: IBizEntity;

  readonly parentExplorer = {
    component: KpiExplorerComponent,
    inputs: {
      isInModal: true,
      functionTypeFilter: null,
      onSelectionChange: (data: IBizEntity | undefined) => {
        this.selectedParentEntity = data;
      }
    },
    data: () => this.selectedParentEntity ?? this.baseEntityFormComponent?.selectedBizEntityObj ?? undefined,
  };
  // Once filter is avaliable this will all be handled by the generic explorer
  // This is a temporary solution until the generic explorer has filter capabilities


    //DQR Specific
  private dqrSelections!: Selections;
  private referenceSource!: IFactAndValue[];
  private bizRule: DataQueryRule =new DataQueryRule(new Selections([], [], this.mathService, false, ""), new FilterExpressions(undefined, this.mathService, false, ""), new GroupBys([]), new MoreSection(0), this.mathService);
  private bizRuleStatusFieldAlias: string | null = null;
  bizRuleSelectionsListerView: IListView = {
    title: 'Selected Facts',
    colHeaders: [{ key: 'factName', label: 'Selected Fact' }],
    items: [],
    headerActions: []
  };


  constructor() {
    let state = initFormStateFunc(this.appStateService);
    this.kpiBizEntity = state.bizEntity as IKPI;
    this.isEditing = state.isEditing;
  }

  ngOnInit(): void {
    if (!this.currentAppId) {
      this.currentAppId = this.appFrameworkContextService.currentAppId;
    }
    this.initializeForm();
    
  }

  private markFlowDataReady(): void {
    this.flowDataReady = true;
    this.tryHideFormLoading();
  }

  private tryHideFormLoading(): void {
    if (this.baseFormReady && this.flowDataReady) {
      this.isFormLoading = false;
    }
  }

  onFormReady(): void {
    this.baseFormReady = true;
    this.tryHideFormLoading();
  }

  /**
   * TO DO
   * This functionalty is going to be to moved on optima components level 
   */
  get isFormValid(): boolean {
    // Validate base entity form (name, description, icon, etc.)
    if (!this.baseEntityFormComponent?.isBaseFormValid) {
      return false;
    }

    // Validate KPI specific fields
    if (this.formLayout?.content?.fieldItems) {
      for (const field of this.formLayout.content.fieldItems) {
        if (field.fieldMeta?.isRequired) {
          let fieldValue;

          // Handle different field types
          if (field.id === 'date-range') {
            // Special handling for date range
            if (!field.dateRangeValueFromString || !field.dateRangeValueToString) {
              field.touched = true;
              return false;
            }

            // Validate dates are valid and from < to
            const fromDate = new Date(field.dateRangeValueFromString);
            const toDate = new Date(field.dateRangeValueToString);

            if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
              field.touched = true;
              return false;
            }

            if (fromDate >= toDate) {
              field.touched = true;
              return false;
            }
          } else if (field.id === 'measure') {
            // Special handling for explorer field
            fieldValue = field.selectedBizEntity;
          } else {
            // Handle regular fields and options
            fieldValue = field.type === PolyMorphicControlTypes.options 
              ? field.optionSelected 
              : field.value;
          }

          field.touched = true;

          // Check if field is empty (for non-date-range fields)
          if (field.id !== 'date-range') {
            if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
              return false;
            }
          }

          // Check if field has inputPattern validation
          if (field.fieldMeta.inputPattern && fieldValue) {
            const pattern = new RegExp(field.fieldMeta.inputPattern);
            if (!pattern.test(fieldValue.toString())) {
              return false;
            }
          }
        }
      }
    }

    // Validate additional info form
   if(this.kpiBizEntity?.type?.additionalFields?.length > 0){
      const isAdditionalInfoValid = this.additionalInfoFormComponent?.isAdditionalInfoValid || false;
      if (!isAdditionalInfoValid) {
        return false;
      }
   }

    if (this.relationshipFieldsComponents?.length > 0) {
      const allRelationshipsValid = this.relationshipFieldsComponents.toArray().every(rf => rf.isFormValid());
      if (!allRelationshipsValid) {
        return false;
      }
    }

    return true;
  }

  get isBizRuleButtonDisabled(): boolean {
    return !this.referenceSource || this.referenceSource.length === 0;
  }


  private initializeForm() {
    if (this.isEditing) {
       this.kpiStateStoreService.getState(this.bizEntityTypeStateStoreService, this.measureStateStoreService, [this.kpiBizEntity?.id])
        .then((result) => {
          this.kpiBizEntity = result?.[0] as IKPI;
          this.bizRuleStatusFieldAlias = this.dqrTransformationMethodsService.getStatusFieldAliasFromAPIFormat(this.kpiBizEntity?.bizRules);
          
          
          this.selectedMeasureObj = this.kpiBizEntity?.measure?.[0] as IMeasure;
      //    console.log('Selected Measure obj - ', this.selectedMeasureObj);
                this.prepareLogFieldStatusOption();
          this.doesBizEntityHaveRelationship(); // Must be called first to populate relationshipConfigurations
        //  console.log('selected measure obj - ', this.selectedMeasureObj);
           this.referenceSource = this.dqrTransformationMethodsService.transformLogFieldToDQRFactandValues(this.selectedMeasureObj?.logFieldsMeta);
          this.relationshipStateStoreService.getState([this.kpiBizEntity?.id?.toString()], this.bizEntityTypeStateStoreService, this.bizEntityStateStoreService, this.bizEntityChildrenStatusStoreService, true).then((relationships) => {
              if (relationships) {
                // console.log('Relationship data for biz entity:', relationships);
                this.extractedTargetBizEntities = this.extractTargetBizEntities(relationships);
              } else {
                // console.log("No relationship data found for biz entity");
              }
            this.buildFormLayout();
            this.formFooterLayout = this.buildFormFooterLayout();
            this.markFlowDataReady();
            }).catch(() => {
                         this.buildFormLayout();
            this.formFooterLayout = this.buildFormFooterLayout();
              this.markFlowDataReady();
            });
    
        }).catch(() => {
          this.markFlowDataReady();
        });
    } else{
        // In create mode, check if there's a context entity from which create was triggered
        const contextEntity = this.appStateService.selectedBizEntityForEdit;
        
        this.doesBizEntityHaveRelationship();
        this.buildFormLayout();
        this.formFooterLayout = this.buildFormFooterLayout();
        
        // If there's a context entity, set it as parent
        if (contextEntity?.id) {
          this.kpiBizEntity.parentId = contextEntity.id.toString();
        }
        
        this.markFlowDataReady();
    }
  }

  private buildFormLayout() {
    const layout: IFormLayout = {
      content: this.buildFormLayoutContent(),
      cssClass: 'ben-form-kpi'
    };
    this.formLayout = layout;
  }


  private buildFormLayoutContent(): IFormLayoutContent {
    return {
      fieldItems: this.buildFormFields()
    };
  }

  private buildFormFooterLayout(): IFormLayout {
    const layoutFooterHeader: IFormLayoutHeader = {
      title: '',
    };
    const layoutFooterContent: IFormLayoutContent = {
      fieldItems: [],
    };
    const layoutFooter: IFormLayoutFooter = {
      actions: [{
        label: this.isEditing ? `Update ${this.kpiBizEntity?.name}` : `Create ${this.kpiBizEntity?.type?.name}`,
        icon: this.isEditing ? 'cilCheckAlt' : 'cilPlus',
      }]
    };
    const layoutFooterMain: IFormLayout = {
      content: layoutFooterContent,
      footer: layoutFooter,
      cssClass: 'ben-form-kpi-footer'
    };
    return layoutFooterMain;
  }

  private callbackOnSelect: (data: IMeasure) => void = (data: IMeasure) => {
    const selectedMeasure = data;
    this.selectedMeasureObj = selectedMeasure;
  // console.log('Selected Measure log field data:', selectedMeasure);
    this.prepareLogFieldStatusOption(selectedMeasure.logFieldsMeta);
   // this.dqrSelections = this.transformLogFieldToDQRSelections(selectedMeasure.logFieldsMeta)
    this.referenceSource = this.dqrTransformationMethodsService.transformLogFieldToDQRFactandValues(selectedMeasure.logFieldsMeta);
    //console.log(`Transformed Selections--`, this.referenceSource);
    const statusField = this.formLayout.content?.fieldItems?.find(field => field.id === 'status-field');
   // console.log('Status field before setting options - ', statusField);
   if (statusField && !this.isEditing) {
      statusField.disabled = false;
      statusField.optionsWithIcon = this.statusOptions;
      statusField.optionSelected = this.statusOptions[0]?.label || '';
      statusField.value = this.statusOptions[0]?.id || '';
    }
  }


  private validateSelection = (data: IBizEntity): boolean => {
    // Add your validation logic here
    // For example, check if the selected measure meets certain criteria
    if (data && data.type) {
      if(data.type.category !== BizEntityTypeCategory.BenzaitenMeasure){
        return false;
      }
    }
    return true; // Valid selection
  }

  private buildFormFields(): IPolymorphicControlMeta[] {
    const fields: IPolymorphicControlMeta[] = [];
    const dateRange: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'date-range',
      type: PolyMorphicControlTypes.rangeDate,
      label: 'Date Range',
      icon: 'cilCalendar',
      value: this.utilService.convertDateToString(this.kpiBizEntity?.validForDuration ? this.kpiBizEntity.validForDuration.from: '') && this.utilService.convertDateToString(this.kpiBizEntity?.validForDuration ? this.kpiBizEntity.validForDuration.to: '') ?
        `${this.utilService.convertDateToString(this.kpiBizEntity.validForDuration ? this.kpiBizEntity.validForDuration.from: '')} - ${this.utilService.convertDateToString(this.kpiBizEntity.validForDuration ? this.kpiBizEntity.validForDuration.to: '')}` : '',
      dateRangeValueFrom: this.kpiBizEntity?.validForDuration?.from || new Date(),
      dateRangeValueTo: this.kpiBizEntity?.validForDuration?.to || new Date(),
      dateRangeValueFromString: this.utilService.convertDateToString(this.kpiBizEntity?.validForDuration ? this.kpiBizEntity.validForDuration.from: ''),
      dateRangeValueToString: this.utilService.convertDateToString(this.kpiBizEntity?.validForDuration ? this.kpiBizEntity.validForDuration.to: ''),
      placeholder: 'Select date range',
      fieldMeta: {
        id: 'date-range',
        name: 'Date Range',
        type: FieldTypes.rangeDate,
        label: ' Date Range Field',
        isRequired: true,
      }
    });

    const getCategoryKeyFromEnum = (categoryValue: KPIAndMeasureCategories | undefined): string => {
      if (categoryValue === undefined) return '';
      return KPIAndMeasureCategories[categoryValue] || '';
    };

    const category: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'category',
      type: PolyMorphicControlTypes.options,
      label: 'Category',
      icon: 'cilLibrary',
      value: getCategoryKeyFromEnum(this.kpiBizEntity?.category) || '',
      optionsWithIcon: this.getCategoryOptions(),
      optionSelected: getCategoryKeyFromEnum(this.kpiBizEntity?.category),
      optionHeader: 'KPI Categories',
      optionPlaceholder: 'Select KPI Category',
      fieldMeta: {
        id: 'category',
        name: 'Category',
        type: FieldTypes.text,
        label: ' Category Field',
        isRequired: true,
      },
    });

    const unit: IPolymorphicControlMeta = this.polymorphicControlService.getC({ id: 'unit', type: PolyMorphicControlTypes.options });
    unit.optionHeader = 'Unit';
    unit.icon = 'cilLoop';
    unit.label = 'Unit';
    unit.floatingLabel = true;
    unit.optionsWithIcon = [];
    unit.options = Units.map(u => ({
      label: `${u.name} (${u.symbol})`,
      id: u.symbol
    } as IOptionWithoutIcon));
    
    // For edit mode, find the option that matches the existing unit
    let selectedUnitOpt: IOptionWithoutIcon | undefined;
    if (this.kpiBizEntity.unit) {
      selectedUnitOpt = unit.options.find(o => o.label.startsWith(this.kpiBizEntity.unit!.name)) || unit.options.find(o => o.label.includes('(%)')) || unit.options[0];
    } else {
      selectedUnitOpt = unit.options.find(o => o.label.includes('(%)')) || unit.options[0];
    }
    
    unit.value = selectedUnitOpt?.id || '';
    unit.optionSelected = selectedUnitOpt?.label || '';
    unit.disabled = false;
    unit.fieldMeta = {
        id: 3,
        name: 'Unit',
        type: FieldTypes.text,
        label: ' Unit Field',
        isRequired: true,
    },
    unit.optionChangeCallback = (data: IOptionWithoutIcon) => {
      unit.value = data.id;
      unit.optionSelected = data.label;
      // Extract symbol from the id (which is already the symbol)
      this.kpiBizEntity.unit = Units.find(u => u.symbol === data.id);
    };
    if(!this.kpiBizEntity.unit && selectedUnitOpt){
      // Extract symbol from the id
      this.kpiBizEntity.unit = Units.find(u => u.symbol === selectedUnitOpt.id);
    }

    const measure: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'measure',
      type: PolyMorphicControlTypes.trigger,
      label: 'Measure',  
      icon: 'cilLayers',
      value: this.selectedMeasureObj ? this.selectedMeasureObj.name : '',
      optionHeader: 'Select Measure',
      optionPlaceholder: 'Select Measure',
      selectedBizEntity: this.selectedMeasureObj  ||  null,
      fieldMeta : {
        id: 'measure-field',
        name: 'Measure',
        type: FieldTypes.bizEntity,
        label: ' Measure Field',
        isRequired: true,
      },
      executeClickCallback: () => { 
      launchExplorerDialog(measure, this.optimaDefaultModalService, this.callbackOnSelect, this.validateSelection);
      },
      explorerSelected: Explorers.Measure.toString()
    });
   // console.log(this.kpiBizEntity.statusFieldName, "status field name");
  //  console.log("All statusOptions:", this.statusOptions);
    const option = this.statusOptions.find(opt => {
      const isMatch = opt.id === this.kpiBizEntity.statusFieldName;
    //  console.log(`Comparing opt.id: ${opt.id} with statusFieldName: ${this.kpiBizEntity.statusFieldName} - Match: ${isMatch}`, opt);
      return isMatch;
    });
  //  console.log(option, "matched option")
  //   const statusField: IPolymorphicControlMeta = this.polymorphicControlService.getC({
  //     id: 'status-field',
  //     type: PolyMorphicControlTypes.options,
  //     label: 'Select Status Field',
  //     icon: 'cil-check-circle',
  //     optionsWithIcon: this.statusOptions,
  //     optionSelected: option?.label || '',
  //     optionHeader: 'Select Status Field',
  //     optionPlaceholder: 'Select',
  //     disabled: true,
  //     value: option?.id || '',
  //       optionChangeCallback: (item: IOptionWithIcon) => {
  // this.kpiBizEntity.statusFieldName = item.id;
  // statusField.value = item.id;
  // statusField.optionSelected = item.label;}
  //   });
//console.log("All references",this.referenceSource)
    const dqrField: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'data-query-rule',
      type: PolyMorphicControlTypes.trigger,
      label:"Data Query Rule",
      icon: 'cil-filter',
      executeClickCallback: () => {
        if(!this.referenceSource || this.referenceSource.length === 0) return
         this.openBizRuleEditor();
     
      },
  //    disabled: !this.referenceSource || this.referenceSource.length === 0

    })

    fields.push(dateRange);
    fields.push(category);
    fields.push(unit);
    fields.push(measure);
    //fields.push(statusField);
   // fields.push(dqrField);
    this.bizRule = this.kpiBizEntity?.bizRules ? this.dqrTransformationMethodsService.populateDQRFromAPIFormat(this.kpiBizEntity.bizRules) : new DataQueryRule(new Selections([], [], this.mathService, false, ""), new FilterExpressions(undefined, this.mathService, false, ""), new GroupBys([]), new MoreSection(0), this.mathService);
    this.bizRuleStatusFieldAlias = this.dqrTransformationMethodsService.getStatusFieldAliasFromAPIFormat(this.kpiBizEntity?.bizRules);
    this.refreshBizRuleSelectionsListerView();
   // console.log('Form fields - ', this.kpiBizEntity?.bizRules);
    return fields;
  }

  prepareLogFieldStatusOption(data?: IFieldMeta[]) {
  //  console.log('Preparing status options with log fields meta:', this.selectedMeasureObj?.logFieldsMeta);
    this.statusOptions = this.selectedMeasureObj?.logFieldsMeta
      ? this.selectedMeasureObj.logFieldsMeta.map((fieldMeta: IFieldMeta) => {
          return {
            id: fieldMeta.name,
            label: fieldMeta.label,
            icon: fieldMeta.icon || '',
            isRequired: fieldMeta.isRequired || false
          };
        })
      : [];
  }

    private extractTargetBizEntities(relationshipData: IBizEntityRelationships[]): IBizEntity[] {
    const targetBizEntities: IBizEntity[] = [];
    relationshipData.forEach((relationship: IBizEntityRelationships) => {
      if (relationship.to && Array.isArray(relationship.to)) {
        relationship.to.forEach((to: IBizEntityRelationTarget) => {
          if (to.target.bizEntity) {
            targetBizEntities.push(to.target.bizEntity as IBizEntity);
          }
        });
      }
    });
    return targetBizEntities;
  }

  private populateKPIFormWithValues(): IKPI {
    this.kpiBizEntity.name = this.baseEntityFormComponent.bizEntityFormValues?.name;
    this.kpiBizEntity.description = this.baseEntityFormComponent.bizEntityFormValues?.description;
    this.kpiBizEntity.icon = this.baseEntityFormComponent.bizEntityFormValues?.icon;
    this.kpiBizEntity.parentId = this.baseEntityFormComponent.bizEntityFormValues?.parentId;
    this.kpiBizEntity.ownerId = this.baseEntityFormComponent.bizEntityFormValues?.ownerId;
    const dateRangeField = this.formLayout.content?.fieldItems?.find(field => field.id === 'date-range');
    if(dateRangeField?.dateRangeValueFromString && dateRangeField?.dateRangeValueToString){
      this.kpiBizEntity.validForDuration = new DateRange(new Date(dateRangeField.dateRangeValueFromString), new Date(dateRangeField.dateRangeValueToString));
    }
    const categoryFieldVal = this.formLayout.content?.fieldItems?.find(field => field.id === 'category')?.optionSelected;
    if(categoryFieldVal){
      const categoryKey = categoryFieldVal.charAt(0).toUpperCase() + categoryFieldVal.slice(1);
      this.kpiBizEntity.category = KPIAndMeasureCategories[categoryKey as keyof typeof KPIAndMeasureCategories] ?? KPIAndMeasureCategories.Progress;
    }
    // Extract symbol from "name (symbol)" format
    const unitOptionSelected = this.formLayout.content?.fieldItems?.find(field => field.id === 'unit')?.value;
    if (unitOptionSelected) {
      const match = unitOptionSelected.match(/\(([^)]+)\)$/);
      const symbol = match ? match[1] : unitOptionSelected.split(' ')[0];
      this.kpiBizEntity.unit = Units.find(u => u.symbol === symbol) || this.kpiBizEntity.unit;
    }
    this.kpiBizEntity.measureId = [this.formLayout.content?.fieldItems?.find(field => field.id === 'measure')?.selectedBizEntity?.id.toString() || '']; // Retain existing measure if not changed
    this.kpiBizEntity.statusFieldName = this.formLayout.content?.fieldItems?.find(field => field.id === 'status-field')?.value;
    this.kpiBizEntity.additionalInfo = this.additionalInfoFormComponent?.additionalInfoFormValues || [];
    return this.kpiBizEntity;
  }

    private getMeasureNameFromId(): string {
    if (this.kpiBizEntity?.measureId && Array.isArray(this.kpiBizEntity?.measure)) {
      const measureIds = Array.isArray(this.kpiBizEntity.measureId) ? this.kpiBizEntity.measureId : [this.kpiBizEntity.measureId];
      const foundMeasure = this.kpiBizEntity.measure.find(m => 
        measureIds.some(id => String(m.id) === String(id))
      );
      return foundMeasure?.name || '';
    }
    return '';
  }

  get kpiBizEntityFormValues(): IKPI {
    return this.populateKPIFormWithValues();
  }

  private doesBizEntityHaveRelationship(): boolean {
    if (this.kpiBizEntity?.type && this.kpiBizEntity.type.relationshipConfiguration && this.kpiBizEntity.type.relationshipConfiguration.length > 0) {
      this.relationshipConfigurations = this.kpiBizEntity.type.relationshipConfiguration;
      return true;
    }
    return false;
  }

  onRelationshipFieldsChange(data: any): void {
  }

  onCreateKPI(): void {

    if(!this.isFormValid){
      this.toastService.toast('Please fill all the required fields');
      return;
    }

    if (this.isAPICallInProgress) {
      this.toastService.toast('Please wait, operation in progress.');
      return;
    }

    this.setAPICallInProgress(true);
    this.populateKPIFormWithValues();
    if (this.isEditing) {
      this.kpiStateStoreService.update(this.kpiBizEntity)?.then(async (response) => {
        this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
        this.baseEntityFormComponent.afterSubmissionSucceeded();
        if (this.doesBizEntityHaveRelationship()) {
          await this.handleEditRelationships();
        }
        this.setAPICallInProgress(false);
      }).catch((error) => {
        this.toastService.toast('Error occured while updating KPI');
        this.setAPICallInProgress(false);
      });
    } else {
      if (this.doesBizEntityHaveRelationship()) {
        this.retrieveAdditionalEntityDetails();
      } else {
        this.kpiStateStoreService.create(this.kpiBizEntity)?.then((response) => {
          // console.log('Create Result:', response);
          notifyStrategyEntityCreated(this.kpiBizEntity, response, () => {
            this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
          });
          this.baseEntityFormComponent.afterSubmissionSucceeded();
          this.setAPICallInProgress(false);
        }).catch((error) => {
          this.toastService.toast('Error occured while creating KPI');
          this.setAPICallInProgress(false);
        });
      }
    }
  }

  getTargetBizEntity(config: IRelationshipConfiguration): IBizEntity[] {
    if (config.targetType === RelationshipTargetType.BizEntityType) {
      return this.extractedTargetBizEntities.filter(
        bizEntity => bizEntity.type?.id.toString() === (config.target as IBizEntityType).id.toString() || 
                     bizEntity.type?.basedOnTypeId?.toString() === (config.target as IBizEntityType).id?.toString()
      );
    } else {
      return this.extractedTargetBizEntities.filter(
        bizEntity => bizEntity.type?.category === (config.target as BizEntityTypeCategory)
      );
    }
  }

  onBizEntityAdditionalInfo(data: {config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[]}[], index: number): void {
    // Since the component now emits an array of blocks/selections for each relationship config,
    // we need to flatten and store all entries. Remove old entries for this config first.
    this.relationshipAdditionalInfo = this.relationshipAdditionalInfo.filter(
      item => item.config !== data[0]?.config
    );
    // Add all new entries
    this.relationshipAdditionalInfo.push(...data);
  }

     onBizEntityAdditionalInfoForEdit(data: {config: IRelationshipConfiguration, bizEntity: IBizEntity}){
      this.relationshipAdditionalInfoForEdit.push(data);
    }

  private async handleEditRelationships(): Promise<void> {
    this.relationshipFieldsComponents?.forEach(rf => rf.getRelationshipFormFieldValues());
    if (this.relationshipAdditionalInfo.length === 0) return;

    const registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
    for (const data of this.relationshipAdditionalInfo) {
      if (data.config.targetType !== RelationshipTargetType.BizEntityType) continue;
      if (!this.kpiBizEntity) continue;

      if (data.config.link === RelationshipLinkType.Tight) {
        const entityParentId = await this.getEntityParentIdForTightlyLinkedEntity(data.config, this.kpiBizEntity);
        const tightlyLinkedBizEntity = this.autoCreateEntitiesService.createBizEntityAutomaticallyFromBizEntity(this.kpiBizEntity, data.name, data.additionalInfo, data.config, entityParentId);
        const tightlyLinkedCategory = tightlyLinkedBizEntity.type.category;
        (tightlyLinkedBizEntity as IKPI & { appId?: string; tenantId?: string }).appId = (tightlyLinkedBizEntity as IKPI).appId;
        (tightlyLinkedBizEntity as IKPI & { appId?: string; tenantId?: string }).tenantId = (tightlyLinkedBizEntity as IKPI).tenantId;
        const transformedTightlyLinked = benBizEntitySyncBeforeSendingToAPI(tightlyLinkedBizEntity as IBenBizEntity, this.userContextService);
        registeredRelationshipRecords.push({
          relationshipType: data.config.relationshipType,
          target: { isNew: true, bizEntity: transformedTightlyLinked, category: tightlyLinkedCategory },
        });
      } else {
        data.additionalInfo.forEach((addInfo: IAdditionalInfo & { selectedBizEntity?: IBizEntity }) => {
          if (addInfo.fieldMeta.type === FieldTypes.bizEntity && addInfo.value) {
            const bizEntity = addInfo.selectedBizEntity || this.bizEntities.find(be => be.id.toString() === addInfo.value.toString());
            if (bizEntity) {
              registeredRelationshipRecords.push({
                relationshipType: data.config.relationshipType,
                target: { isNew: false, bizEntity: bizEntity.id, category: bizEntity?.type?.category },
              });
            }
          }
        });
      }
    }

    if (registeredRelationshipRecords.length === 0) return;

    const relations: IBizEntityRelationships = {
      from: { isNew: false, bizEntity: this.kpiBizEntity.id, category: this.kpiBizEntity.type.category },
      to: registeredRelationshipRecords,
    };
    await this.relationshipStateStoreService.create(relations, false)?.catch((error) => {
      this.toastService.toast(`Error updating relationships: ${error}`);
    });
  }

     async retrieveAdditionalEntityDetails(){
      if(!this.doesBizEntityHaveRelationship()){
        return;
      }

      if(this.isRelationshipAdditionalInfoValid()){
        // if(this.isFormValid){
          if(!this.isEditing){
            let registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
            for (const data of this.relationshipAdditionalInfo) {
              let targetType = data.config.targetType;
              if(targetType === RelationshipTargetType.BizEntityType)
              {
                if(!this.kpiBizEntity){ continue;}
                if(data.config.link === RelationshipLinkType.Tight){
                  const entityParentId = await this.getEntityParentIdForTightlyLinkedEntity(data.config, this.kpiBizEntity);
                  let tightlyLinkedBizEntity = this.autoCreateEntitiesService.createBizEntityAutomaticallyFromBizEntity(this.kpiBizEntity, data.name, data.additionalInfo, data.config, entityParentId);
                  const tightlyLinkedCategory = tightlyLinkedBizEntity.type.category;
                  (tightlyLinkedBizEntity as IKPI & { appId?: string; tenantId?: string }).appId = (tightlyLinkedBizEntity as IKPI).appId;
                  (tightlyLinkedBizEntity as IKPI & { appId?: string; tenantId?: string }).tenantId = (tightlyLinkedBizEntity as IKPI).tenantId;
                  const transformedTightlyLinked = benBizEntitySyncBeforeSendingToAPI(tightlyLinkedBizEntity as IBenBizEntity, this.userContextService);
                  registeredRelationshipRecords.push({
                    relationshipType: data.config.relationshipType,
                    target:{
                      isNew:true,
                      bizEntity: transformedTightlyLinked,
                      category: tightlyLinkedCategory
                    },
                  });
                } else{
                  // let bizEntity = this.benBizEntites.find(bizEntity => bizEntity.id.toString() === data.additionalInfo[0].value.toString());
                  data.additionalInfo.forEach((addInfo: IAdditionalInfo & { selectedBizEntity?: IBizEntity }) => {
                    if(addInfo.fieldMeta.type === FieldTypes.bizEntity && addInfo.value){
                      let bizEntity = addInfo.selectedBizEntity || this.bizEntities.find(bizEntity => bizEntity.id.toString() === addInfo.value.toString());
                      if(bizEntity){
                        registeredRelationshipRecords.push({
                          relationshipType: data.config.relationshipType,
                          target:{
                            isNew:false,
                            bizEntity: bizEntity.id,
                            category: bizEntity?.type.category
                          },
                        });
                      }
                    }
                  });
                  // if(bizEntity){
                  //   registeredRelationshipRecords.push({
                  //     relationshipType: data.config.relationshipType,
                  //     target:{
                  //       isNew:false,
                  //       bizEntity: bizEntity.id,
                  //       category: bizEntity?.type.category
                  //     },
                  //   });
                  // }
                }
              }
            }
            (this.kpiBizEntity as IKPI & { appId?: string; tenantId?: string }).appId = (this.kpiBizEntity as IKPI).appId;
            (this.kpiBizEntity as IKPI & { appId?: string; tenantId?: string }).tenantId = (this.kpiBizEntity as IKPI).tenantId;
            const transformedBizEntity = temporarykpiSyncBeforeSendingToAPI(this.kpiBizEntity as IKPI, this.userContextService);
            let relations: IBizEntityRelationships = {
              from:{
                isNew: true,
                bizEntity: transformedBizEntity,
                category: (this.kpiBizEntity!).type.category
              },
              to: registeredRelationshipRecords,
            }
            this.relationshipStateStoreService.create(relations, false)?.then((response)=>{
                  notifyStrategyEntityCreated(this.kpiBizEntity, response, () => {
                    this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
                  });
                  this.baseEntityFormComponent.afterSubmissionSucceeded();
                  this.setAPICallInProgress(false);
            }).catch((error) => {
              this.toastService.toast(`Error creating relationships: ${error}`);
              this.setAPICallInProgress(false);
            });
          }
          else{
            this.setAPICallInProgress(false);
            // let registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
            // this.relationshipAdditionalInfoForEdit.forEach((data: {config: IRelationshipConfiguration, bizEntity: IBizEntity}) => {
            //   registeredRelationshipRecords.push({
            //     relationshipType: data.config.relationshipType,
            //     target: {
            //       isNew: false,
            //       bizEntity: data.bizEntity?.id || '',
            //       category: data.bizEntity?.type?.category!
            //     },
            //   });
            // });
            // let relations: IBizEntityRelationships = {
            //   from:{
            //     isNew: false,
            //     bizEntity: this.bizEntity?.id || '',
            //     category: this.bizEntity?.type?.category!
            //   },
            //   to: registeredRelationshipRecords,
            // }
            // // console.log("this.relationshipAdditionalInfoForEdit", relations);
            // // this.relationshipStateStoreService.update(relations, this.userService);
          }
        // }
      }
      else{
        this.toastService.toast('Please provide all the fields of the related entity Biz Entity.');
        this.setAPICallInProgress(false);
      }
    }

  private setAPICallInProgress(inProgress: boolean): void {
    this.isAPICallInProgress = inProgress;
    //TO Do : This diable/enable the submit button in the footer should be handled using key instead of index 0
    if (this.formFooterLayout && this.formFooterLayout.footer && this.formFooterLayout.footer.actions.length > 0) {
    this.formFooterLayout.footer.actions[0].isDisabled = inProgress;
  }
  }

  isRelationshipAdditionalInfoValid(): boolean {
    // Trigger all relationship field components to emit their data
    this.relationshipFieldsComponents.forEach(relationshipField => {
      // console.log("Triggering getRelationshipFormFieldValues for ", relationshipField);
      relationshipField.getRelationshipFormFieldValues();
    });

    let isValid = true;
    this.relationshipAdditionalInfo.forEach((data: {config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[]}) => {
      data.additionalInfo.forEach((addInfo: IAdditionalInfo) => {
        if (addInfo.fieldMeta.isRequired && !addInfo.value) {
          isValid = false;
          return;
        }
      });
    });

    return isValid;
  }
  onBizRulesDialogClosed = (data: any) => {
   // console.log('Biz Rule Dialog Closed - Data received:', data);
    
    if (!data) {
      console.error('No data received from Biz Rule dialog');
      return;
    }
    //console.log("All the data",data)

//   console.log("consoling the types ---",
//   data.selections instanceof Selections,
//   data.filterExpressions instanceof FilterExpressions,
//   data.groupBys instanceof GroupBys,
//   data.more instanceof MoreSection
// );

    if (data.selections && data.groupBys && data.filterExpressions) {
      const selectedStatusFieldAlias = data.selectedStatusFieldAlias || this.bizRuleStatusFieldAlias || null;
      this.bizRuleStatusFieldAlias = selectedStatusFieldAlias;
     
      const transformedRule = new DataQueryRule(
        data.selections, 
        data.filterExpressions,
        data.groupBys, 
        data.more || { limit: 0 }, 
        this.mathService
      );
      
      this.bizRule = transformedRule;
      this.refreshBizRuleSelectionsListerView();
   //   console.log("DQR Rule where clause type check:", this.bizRule.selections instanceof Selections);
    //   console.log(this.bizRule.where instanceof FilterExpressions);
    //  console.log("DQR Rule: complete",this.bizRule)
    //  console.log("---- data.more ----", data.more);
      // Transform selections to the desired format
          const categoryFieldVal = this.formLayout.content?.fieldItems?.find(field => field.id === 'category')?.optionSelected;
      const transformedSelections = this.dqrTransformationMethodsService.prepareDqrParameters(
        data.selections,
        data.filterExpressions,
        data.groupBys,
        data.more,
        this.referenceSource || [],
        selectedStatusFieldAlias,
        categoryFieldVal ? categoryFieldVal === KPIAndMeasureCategories[KPIAndMeasureCategories.Progress] : false
      );
   //   console.log('Transformed Selections Format:', transformedSelections);
      this.kpiBizEntity.bizRules = transformedSelections;
     // console.log('Created Selection', data.selections?.selects);
      // data.selections?.selects.forEach((selection: Selection) => {
      //   console.log('Selection Fact:', selection.factAndValue.fact);
      // });
      

    //  console.log('Biz Rule Details:', currentRule);
      
      // TODO: Store the biz rule in the KPI or perform additional actions
      // this.kpiBizEntity.bizRule = bizRule;
    } else {
      console.error('Incomplete data received:', {
        hasSelections: !!data.selections,
        hasGroupBys: !!data.groupBys,
        hasFilterExpressions: !!data.filterExpressions
      });
    }
  }
    private getDefaultBizRuleSelections(): Selections {
    const defaultSelection = new Selection(
      {
        fact: {
          name: 'datetime',
          columnAlias: 'date'
        },
        dataType: QueryDataTypes.DATE,
        valueKind: ValueKinds.NONE,
        value: ''
      },
      faker.string.uuid(),
      FactDefinitionTypes.Field,
      OrderByDirections.NONE,
      false,
      false,
      false,
      false
    );

    return new Selections([defaultSelection], [], this.mathService, false, '');
  }
  //Biz Rule Editor
   openBizRuleEditor() {
    const combinedReferences: IFactAndValue[] = [
      ...(this.referenceSource || []),
      ...(this.bizRule?.selections?.dynamicReferences || [])
    ];
 

  //  console.log("Filter Expressions--", filterExpressions);
    let modalConfig = GetDefaultConfig()
    modalConfig.title = 'Biz Rule Editor';
    modalConfig.dialog = ModalDialogs.BizRules;
    modalConfig.size = ModalDialogSizes.XL;
    modalConfig.model = {
  in: {
    preDefinedReferences: combinedReferences,
selections: this.bizRule?.selections?.selects?.length ? this.bizRule.selections : this.getDefaultBizRuleSelections(),
   filterExpressions:  new FilterExpressions( this.bizRule.where.condition || [], this.mathService, false, ""),
    groupBys: this.bizRule?.groupBys ?? new GroupBys([]),
    more: this.bizRule?.more ?? new MoreSection(0),
    selectedStatusFieldAlias: this.bizRuleStatusFieldAlias,
    isProgressKpi: this.formLayout.content?.fieldItems?.find(field => field.id === 'category')?.optionSelected === KPIAndMeasureCategories[KPIAndMeasureCategories.Progress]

  },
  out: null
};
    modalConfig.footerButtons.push({
      id: ModalButtonIDs.BizRule_Save,
      label: 'Save',
      color: 'primary',
      click: (data: any) => {
        this.onBizRulesDialogClosed(data);
      },
      getData: true,
      formValidate: false,
      isEnabled: (data: any) => {
             const hasStatusField = (data?.selectedStatusFieldAlias?.length ?? 0) > 0; 
        // Check if any component has errors
        const hasErrors = 
          (data.selections?._hasErrors ||
          data.filterExpressions?._hasErrors ||
          data.groupBys?._hasErrors);
        return !hasErrors && hasStatusField;
      },
      closesModal: true,
    })
    this.optimaDefaultModalService.show(modalConfig);
  }

  private refreshBizRuleSelectionsListerView(): void {
    const selectionNameMetaData: IFieldMeta = {
      id: 1,
      name: 'factName',
      label: 'Selected Fact',
      type: FieldTypes.text,
      isRequired: false
    };

    const items = (this.bizRule?.selections?.selects || []).map((selection: Selection, index: number) => ({
      id: selection.key || `${index}`,
      columns: [
        {
          key: 'factName',
          label: 'Selected Fact',
          value: selection.factAndValue?.fact?.columnAlias || '',
          metaData: selectionNameMetaData,
          bizInformationType: BizInformationTypes.text
        }
      ]
    }));

    this.bizRuleSelectionsListerView = {
      title: 'Selected Facts',
      colHeaders: [{ key: 'factName', label: 'Selected Fact' }],
      items,
      headerActions: []
    };
  }


  private getCategoryOptions(): IOptionWithIcon[] {
    const iconMap: { [key in KPIAndMeasureCategories]?: string } = {
      [KPIAndMeasureCategories.Progress]: 'cilArrowTop',
      [KPIAndMeasureCategories.Performance]: 'cilSpeedometer',
      [KPIAndMeasureCategories.Quality]: 'cilStar',
      [KPIAndMeasureCategories.Innovation]: 'cilLightbulb',
      [KPIAndMeasureCategories.Composite]: 'cilPuzzle',
      [KPIAndMeasureCategories.Misc]: 'cilLayers',
      [KPIAndMeasureCategories.Historical_Progress]: 'cilChart',
      [KPIAndMeasureCategories.Placeholder_2]: 'cilCircle',
      [KPIAndMeasureCategories.Placeholder_3]: 'cilCircle'
    };

    return Object.keys(KPIAndMeasureCategories)
      .filter(key => isNaN(Number(key)))
      .map(key => {
        const enumValue = KPIAndMeasureCategories[key as keyof typeof KPIAndMeasureCategories];
        return {
          id: key.toLowerCase(),
          label: key,
          icon: iconMap[enumValue] || 'cilTags'
        };
      });
  }

  async getEntityParentIdForTightlyLinkedEntity(config: IRelationshipConfiguration, currentEntity: IBizEntity): Promise<string | undefined> {
    if(config?.targetType === RelationshipTargetType.BizEntityType){
      const targetBizEntityTypeAppId = (config.target as IBizEntityType).appId;
      if(targetBizEntityTypeAppId && this.currentAppId !== targetBizEntityTypeAppId){
        // const tenants = await this.tenantStateStoreService.fetch();
        // const tenant = tenants?.[0];
        // return tenant?.id;
        const xappCap = {
          appId: targetBizEntityTypeAppId,
        }

        const appRootEntity = await this.appRootStateStoreService.get(undefined, undefined, xappCap);
        return appRootEntity?.id?.toString();
      }
      return currentEntity.parentId?.toString();
    }
    return undefined;
  }

}